export default "__VITE_ASSET__Bgm5aEQJ__"